import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "scd__panel",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "계약서 삭제"
}
const _hoisted_2 = { class: "scd__head" }
const _hoisted_3 = { class: "scd__lead" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "scd__error",
  role: "alert"
}
const _hoisted_6 = { class: "scd__foot" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

import { nextTick, ref, watch } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractDeleteModal',
  props: {
    open: { type: Boolean },
    orgName: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const password = ref('')
const inputEl = ref<HTMLInputElement | null>(null)

watch(
  () => props.open,
  (open) => {
    if (!open) {
      password.value = ''
      return
    }
    nextTick(() => inputEl.value?.focus())
  },
)

function onSubmit() {
  if (props.busy || !password.value.trim()) return
  emit('confirm', password.value.trim())
}

return (_ctx: any,_cache: any) => {
  return (__props.open)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "scd",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("header", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "scd__title" }, "계약서 삭제", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "scd__x",
              "aria-label": "삭제 창 닫기",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, [
              _createVNode(AppIcon, {
                icon: "mdi-close",
                size: 20
              })
            ])
          ]),
          _createElementVNode("form", {
            class: "scd__body",
            onSubmit: _withModifiers(onSubmit, ["prevent"])
          }, [
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("strong", null, _toDisplayString(__props.orgName || '기관명 없음'), 1),
              _cache[5] || (_cache[5] = _createTextVNode(" 계약서를 삭제합니다. 비밀번호를 다시 입력해 주세요. ", -1))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              class: "scd__label",
              for: "scd-password"
            }, "비밀번호", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "scd-password",
              ref_key: "inputEl",
              ref: inputEl,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              class: "scd__input",
              type: "password",
              inputmode: "numeric",
              autocomplete: "current-password",
              disabled: __props.busy
            }, null, 8, _hoisted_4), [
              [_vModelText, password.value]
            ]),
            (__props.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("footer", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "scd__btn scd__btn--ghost",
                disabled: __props.busy,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
              }, " 닫기 ", 8, _hoisted_7),
              _createElementVNode("button", {
                type: "submit",
                class: "scd__btn scd__btn--danger",
                disabled: __props.busy || !password.value.trim()
              }, _toDisplayString(__props.busy ? '삭제 중…' : '삭제'), 9, _hoisted_8)
            ])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})